<template>
    <BasePage class="relative-position" style="background-color: #E6F1FE">
        <div class="flex flex-center" style="margin-top: 10%">
            <img src="~assets/ui/kurs-1t-logo.svg" style="object-fit: contain" />
        </div>
        <div class="flex flex-center" style="margin-top: 50px">
            <img src="~assets/ui/login-image.svg" style="object-fit: contain" />
        </div>
        <div class="absolute-bottom full-width" style="margin-bottom: -10px; z-index: 0; height: 50%">
            <img src="~assets/ui/login-bottom-area.svg" style="object-fit: cover; object-position: top" class="fit" />
        </div>
        <div style="padding: 0 25px 0 25px; z-index: 1; position: absolute; bottom: 0; height: 45%" class="column text-center q-gutter-y-sm full-width no-wrap text-white">
            <div class="text-h5">Цифровые профессии</div>
            <div class="text-body1 text-weight-medium" style="color: #cce3fe">для высших учебных заведений</div>

            <div class="col column justify-center q-gutter-y-xs no-wrap">
                <!--<DefaultButton label="Войти через Telegram" @click="loginTg" />-->
                <DefaultButton label="Войти" @click="login" />
                <DefaultButton label="Регистрация" @click="register" />
                <DefaultButton label="Войти через ВКонтакте" @click="loginVk" class="bg-white" text-color="black" />
            </div>
            <q-space />
            <div class="text-white text-left" style="font-size: 8pt; padding: 0 15px 15px 15px">
                Регистрируясь в приложении, вы даете
                <a class="text-white" href="https://obr.so/wp-content/themes/obrsouz/assets/docs/consent-personal-data.pdf">Согласие на обработку персональных данных</a> и принимаете
                <a class="text-white" href="https://obr.so/wp-content/themes/obrsouz/assets/docs/policy-personal-data.pdf">Политику в отношении обработки персональных данных</a>
            </div>
        </div>
    </BasePage>
</template>

<script>
import md5 from 'js-md5';
import { sendSmsMessage } from 'boot/axios';
import DefaultButton from 'components/ui/common/DefaultButton';
import BasePage from 'pages/BasePage';

export default {
    name: 'PageLogin',
    components: {
        BasePage,
        DefaultButton,
    },
    mounted () {
        this.isCodeSent = false;
        this.dontAllow = true;
    },
    watch: {
        tel (v) {
            this.dontAllow = v && (v.length <= 10);
        },
        /*
        inputCode (v) {
            if (v && v.length === 4) {
                this.$nextTick(() => {
                    this.login();
                });
            }
        },
        */
    },
    data () {
        return {
            loading: false,
            isCodeSent: false,
            tel: undefined,
            code: undefined,
            inputCode: undefined,
            user: undefined,
            isRegistration: false,
            dontAllow: true,
            codeHint: undefined,
        };
    },
    computed: {
        pureTel () {
            let { tel } = this;
            tel = tel.replaceAll('+', '');
            tel = tel.replaceAll('(', '');
            tel = tel.replaceAll(')', '');
            tel = tel.replaceAll('-', '');
            tel = tel.replaceAll(' ', '');
            return tel;
        },
    },
    methods: {
        getCode () {
            if (!this.tel) {
                this.$refs.phone.select();
                this.$q.notify('Укажите номер телефона');
                return;
            }
            this.loading = true;
            this.isCodeSent = false;
            this.loading = true;
            this.$db.users.findByTel(this.pureTel).then((u) => {
                if (!u) {
                    this.loading = false;
                    this.confirmRegister();
                    return;
                }
                this.createCode(u);
            });
        },
        createCode (user) {
            this.$db.users.createCode(this.pureTel).then((code) => {
                this.code = code;
                this.loading = false;
                this.isCodeSent = true;
                this.user = user;
                sendSmsMessage(this.pureTel, `Ваш код: ${code}`);
                setTimeout(() => {
                    // this.codeHint = `Ваш код СМС: ${code}`;
                    this.inputCode = code.toString();
                }, 1000 * 60 * 3);
                this.$nextTick(() => {
                    this.$refs.code.select();
                });
            });
        },
        loginOld () {
            if (!this.inputCode) {
                this.$refs.code.select();
                this.$q.notify('Введите код из СМС-сообщения');
                return;
            }
            if (+this.inputCode !== +this.code) {
                this.$refs.code.select();
                this.$q.notify('Неправильный код подтверждения');
                return;
            }
            if (this.isRegistration) {
                this.register();
                return;
            }

            this.$db.users.removeFromPreregister(this.pureTel);
            const hash = md5(this.user.chat_id).substring(0, 12);
            localStorage.setItem('key', hash);
            this.$store.commit('pages/setUser', { ...this.user });
            this.$db.users.validateTel(this.user.id, this.pureTel);
            this.$pages.back();
        },
        confirmRegister () {
            this.loading = false;
            this.$q.notify({
                message: 'Вы хотите зарегистрироваться?',
                color: 'primary',
                timeout: 30000,
                actions: [
                    { label: 'Зарегистрироваться', color: 'yellow', handler: () => { this.createCode(); this.isRegistration = true; } },
                    { label: 'Нет', color: 'white', handler: () => { /* ... */ } },
                ],
            });
        },
        registerOld () {
            const user = {
                shownname: '',
                region_name: '',
                school_number: '',
                position: '',
                tel: this.pureTel,
            };
            this.$db.users.create(user).then(() => {
                const hash = md5(user.chat_id).substring(0, 12);
                localStorage.setItem('key', hash);
                this.$store.commit('pages/setUser', { ...user });
                this.$pages.back();
                // this.$pages.popCurrentPage();
                // this.$pages.internalPush({ type: 'PageBio', title: 'Добро пожаловать!', hide_logout: true });
            }).catch(() => {
                this.$q.notify('Во время регистрации произошла ошибка');
            });
        },
        loginTg () {
            // вернуть отладочный бот
            let url = 'https://t.me/Kurs1TBot?start=from_club';
            if (this.$route.fullPath.startsWith('/go/')) {
                url = `https://t.me/Kurs1TBot?start=from_club=go_${this.$route.fullPath.replace('/go/', '')}`;
            }
            window.open(url, '_blank');
        },
        loginVk () {
            let useNextRedirect = '0';
            if (this.$route.href.startsWith('/next')) {
                useNextRedirect = '1';
            }
            let url = `${window.location.origin}/sot.bot/vk_app/api/auth.php?next=${useNextRedirect}`;
            if (this.$route.fullPath.startsWith('/go/')) {
                url = `${window.location.origin}/sot.bot/vk_app/api/auth.php?state=go_${this.$route.fullPath.replace('/go/', '')}&next=${useNextRedirect}`;
            }
            window.open(url, '_blank');
        },
        login () {
            this.$router.push({ path: '/d/login' });
        },
        register () {
            this.$router.push({ path: '/d/register' });
        },
    },
};
</script>

<style scoped>

</style>
